const CroatiaSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4152_111237)">
      <path
        d="M40 19.9989C40 17.5525 39.5599 15.209 38.756 13.0425L20 12.1729L1.24398 13.0424C0.440078 15.209 0 17.5525 0 19.9989C0 22.4454 0.440078 24.7889 1.24398 26.9554L20 27.825L38.756 26.9555C39.5599 24.7889 40 22.4454 40 19.9989Z"
        fill="#F0F0F0"
      />
      <path
        d="M19.9997 40.0005C28.599 40.0005 35.9298 34.573 38.7557 26.957H1.24365C4.06951 34.573 11.4004 40.0005 19.9997 40.0005Z"
        fill="#0052B4"
      />
      <path
        d="M1.24365 13.0435H38.7558C35.9298 5.4275 28.599 0 19.9997 0C11.4004 0 4.06951 5.4275 1.24365 13.0435Z"
        fill="#D80027"
      />
      <path
        d="M25.2171 13.9142H21.7388L22.3185 9.56629L24.6373 7.82715L26.9561 9.56629V13.0446L25.2171 13.9142Z"
        fill="#338AF3"
      />
      <path
        d="M14.7825 13.9142H18.2608L17.681 9.56629L15.3622 7.82715L13.0435 9.56629V13.0446L14.7825 13.9142Z"
        fill="#338AF3"
      />
      <path
        d="M22.319 13.9142H17.6812V9.56629L20.0001 7.82715L22.319 9.56629V13.9142Z"
        fill="#0052B4"
      />
      <path
        d="M13.0435 13.043V22.6081C13.0435 24.8857 14.1436 26.9112 15.8405 28.1809L17.0579 27.8763L18.5942 29.4218C19.0485 29.5154 19.5185 29.5647 20 29.5647C20.4789 29.5647 20.9467 29.516 21.3985 29.4234L23.1522 27.9632L24.1594 28.1781C25.8556 26.9084 26.9565 24.8851 26.9565 22.6081V13.043H13.0435Z"
        fill="#F0F0F0"
      />
      <path d="M13.0435 13.043H15.826V15.8255H13.0435V13.043Z" fill="#D80027" />
      <path d="M18.6084 13.043H21.391V15.8255H18.6084V13.043Z" fill="#D80027" />
      <path d="M24.1733 13.043H26.9559V15.8255H24.1733V13.043Z" fill="#D80027" />
      <path d="M15.8262 15.8252H18.6087V18.6078H15.8262V15.8252Z" fill="#D80027" />
      <path d="M21.3911 15.8252H24.1737V18.6078H21.3911V15.8252Z" fill="#D80027" />
      <path d="M13.0435 18.6084H15.826V21.391H13.0435V18.6084Z" fill="#D80027" />
      <path d="M15.8262 21.3906H18.6087V24.1732H15.8262V21.3906Z" fill="#D80027" />
      <path d="M18.6084 18.6084H21.391V21.391H18.6084V18.6084Z" fill="#D80027" />
      <path d="M24.1733 18.6084H26.9559V21.391H24.1733V18.6084Z" fill="#D80027" />
      <path d="M21.3911 21.3906H24.1737V24.1732H21.3911V21.3906Z" fill="#D80027" />
      <path d="M18.6084 24.1729H21.391V26.9554H18.6084V24.1729Z" fill="#D80027" />
      <path
        d="M15.8257 24.1729H13.2227C13.4614 25.2072 13.9308 26.1537 14.5744 26.9554H15.8257V24.1729Z"
        fill="#D80027"
      />
      <path
        d="M24.1733 26.9554H25.4246C26.0683 26.1537 26.5376 25.2071 26.7763 24.1729H24.1733V26.9554Z"
        fill="#D80027"
      />
      <path
        d="M15.8262 26.957V28.1712C16.6355 28.7802 17.5812 29.2168 18.6087 29.4263V26.957H15.8262Z"
        fill="#D80027"
      />
      <path
        d="M21.3911 26.957V29.4263C22.4187 29.217 23.3644 28.7802 24.1737 28.1712V26.957H21.3911Z"
        fill="#D80027"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_111237">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default CroatiaSvg;
